import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={94} height={24} fill="none" {...props}>
        <Path
            fill={ds.colorValue.icon.primary}
            fillRule="evenodd"
            d="m.005 15.937 1.84-12.416c.07-.475.438-.852.911-.936L17.366.009a.559.559 0 0 1 .594.804l-4.144 8.131c-.21.411.14.884.594.804l3.814-.673c.544-.096.882.573.482.956L4.201 23.843c-.415.394-1.084-.015-.92-.564l1.993-6.702a.558.558 0 0 0-.633-.71l-3.985.703a.56.56 0 0 1-.65-.633H.005Zm9.019-5.606c.713.28 1.169.458 1.006-.46-.286-1.628-1.812-2.72-3.408-2.438-1.594.281-2.655 1.829-2.369 3.457.163.918.529.595 1.104.087.445-.392 1.015-.895 1.711-1.018.696-.123 1.403.154 1.956.372Z"
            clipRule="evenodd"
        />
        <Path
            fill={ds.colorValue.icon.primary}
            d="M48.292 12.08c0 4.42 4.06 7.44 9 7.44 2.08 0 3.96-.5 5.08-1.32l.54-4.5c-1.46 1.32-3.36 2.08-5.16 2.08-2.54 0-4.68-1.46-4.68-3.8 0-2.32 2.2-3.76 4.64-3.76 1.8 0 3.5.74 4.94 2.04l-.12-4.56c-1.54-.86-3.4-1.22-5.08-1.22-5.54 0-9.16 3.44-9.16 7.6ZM86.428 19.52c-2.34 0-4.82-.78-5.96-1.88l-.1-4.48c1.32 1.62 3.72 2.78 5.92 2.78 1.36 0 2.26-.42 2.26-1.1 0-.717-1.128-1.002-2.587-1.371a42.82 42.82 0 0 1-1.172-.31c-2.8-.74-4.56-2.1-4.56-4.26 0-2.62 2.82-4.42 6.44-4.42 2.22 0 4.5.7 5.64 1.44l.28 4.2c-1.76-1.36-3.92-2.1-5.9-2.1-1.24 0-2.12.34-2.12.92 0 .615.808.824 2.372 1.23.373.096.789.204 1.248.33 2.92.72 4.88 1.96 4.88 4.3 0 2.78-2.96 4.72-6.64 4.72Z"
        />
        <Path
            fill={ds.colorValue.icon.primary}
            d="m74.553 19.26-5.44-6.1v6.1h-4.38V4.74h4.38v5.64l5.6-5.64h5.56l-7.12 6.86 7.04 7.66h-5.64ZM42.176 19.26V4.74h4.44v14.52h-4.44Z"
        />
        <Path
            fill={ds.colorValue.icon.primary}
            fillRule="evenodd"
            d="M26.881 4.74v14.52h4.38v-4.18h2.62c4.72 0 6.9-2.42 6.9-5.24 0-2.64-1.82-5.1-7.02-5.1h-6.88Zm9.2 5.14c0 1.2-1.12 1.78-2.62 1.78h-2.2v-3.5h2.2c1.58 0 2.62.54 2.62 1.72Z"
            clipRule="evenodd"
        />
    </Svg>
);
export default SvgComponent;
